import { EmptyItem as EmptyItem_zoomg } from './EmptyItem.zoomg';
import { EmptyItem as EmptyItem_pedal } from './EmptyItem.pedal';
import { EmptyItem as EmptyItem_zoomit } from './EmptyItem.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'zoomg':
      return EmptyItem_zoomg;

    case 'pedal':
      return EmptyItem_pedal;

    default:
      return EmptyItem_zoomit;
  }
};

export const EmptyItem = IconRenderer();
